<template>
  <div>
    <v-dialog v-model="dialogData" width="500" persistent>
      <v-card>
        <v-card-title> Ubah Rekening </v-card-title>
        <v-card-text>
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-alert
                    v-model="flashError"
                    dense
                    border="left"
                    type="error"
                    dismissible
                    elevation="2"
                  >
                    {{ flashErrorMessage }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> Nomor Rekening </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  <v-text-field
                    id="noRekening"
                    ref="noRekening"
                    v-model="accountNumber"
                    @change="$v.accountNumber.$touch()"
                    @blur="$v.accountNumber.$touch()"
                    :error-messages="accountNumberErrors"
                    :loading="isloadingRekening"
                  />
                </v-col>
              </v-row>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> ID Approver 1 </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  <v-autocomplete
                    id="IDApprover1"
                    ref="IDApprover1"
                    clearable
                    v-model="IDApprover1"
                    :items="itemsApprovalId1"
                    item-id="id"
                    item-text="username"
                    return-object
                    @change="$v.IDApprover1.$touch()"
                    @blur="$v.IDApprover1.$touch()"
                    @focus="onFocusApprover1"
                    :error-messages="IDApprover1Errors"
                    :loading="isLoadingApprovalId1"
                    :search-input.sync="searchApprovalId1"
                    hide-selected
                  />
                </v-col>
              </v-row>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> ID Approver 2 </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  <v-autocomplete
                    id="IDApprover2"
                    ref="IDApprover2"
                    clearable
                    v-model="IDApprover2"
                    :items="itemsApprovalId2"
                    item-id="id"
                    item-text="username"
                    return-object
                    @change="$v.IDApprover2.$touch()"
                    @blur="$v.IDApprover2.$touch()"
                    @focus="onFocusApprover2"
                    :error-messages="IDApprover2Errors"
                    :loading="isLoadingApprovalId2"
                    :search-input.sync="searchApprovalId2"
                    hide-selected
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn dark color="red" @click="cancelDialog"> Cancel </v-btn>
          <v-btn
            color="primary"
            @click="save"
            :disabled="loading"
            :loading="loading"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" width="400" persistent>
      <notif-dialog
        :icon="'mdi-chart-bubble'"
        :title="'Perubahan data menunggu proses approval ! Jika diapprove, maka resettlement akan segera di proses.'"
        v-on:closeCancelParent="close"
        v-on:confirmParent="save"
      />
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, numeric } from 'vuelidate/lib/validators';
import { isEmpty, date, showAlert } from '../../lib/helpers';
import { dataUserRoles, dataDelayServiceHit } from '../../store/params';

export default {
  components: {
    notifDialog: () => import('../NotifDialog.vue'),
  },
  props: {
    editedItem: {
      type: Object,
      default: null,
    },
    dialogMS: {
      type: Boolean,
      default: false,
    },
    editedIndex: {
      type: Number,
      default: null,
    },
  },
  mixins: [validationMixin],
  validations: {
    accountNumber: {
      required,
      numeric,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.accountNumber == null ||
            this.errorValidation.accountNumber.length < 1)
        );
      },
    },
    IDApprover1: {
      required() {
        return this.IDApprover1 != null && !isEmpty(this.IDApprover1.user_id);
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.approver_1 == null ||
            this.errorValidation.approver_1.length < 1)
        );
      },
    },
    IDApprover2: {
      required() {
        return this.IDApprover2 != null && !isEmpty(this.IDApprover2.user_id);
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.approver_2 == null ||
            this.errorValidation.approver_2.length < 1)
        );
      },
    },
  },
  data: () => ({
    isLoadingApprovalId1: false,
    isLoadingApprovalId2: false,
    searchApprovalId1: '',
    searchApprovalId2: '',
    approver1Loaded: false,
    approver2Loaded: false,
    delayHitServiceA1: null,
    delayHitServiceA2: null,
    listUserRoles: dataUserRoles,
    dialog: false,
    isloadingRekening: false,
    accountNumber: '',
    IDApprover1: { username: '', user_id: '' },
    IDApprover2: { username: '', user_id: '' },
  }),
  computed: {
    dialogData() {
      return this.dialogMS;
    },
    flashErrorMessage() {
      const errorData = this.errorValidation.message
        ? this.errorValidation.message
        : this.$store.state.maintenanceSettlement.flashErrorMessage;
      return errorData;
    },

    flashError: {
      get() {
        return this.$store.state.maintenanceSettlement.flashError;
      },
      set() {
        this.$store.commit('maintenanceSettlement/setFlashErrorMessage', '');
      },
    },

    itemsApprovalId1() {
      const storeList = this.$store.state.master.daerah.list.approvalId1;
      
      if (storeList.length === 0 && this.editedItem && this.editedItem.approver_1_id) {
        return [{
          id: this.editedItem.approver_1_id,
          username: this.editedItem.approver_1,
          user_id: this.editedItem.approver_1_id,
        }];
      }
      
      const list = storeList.find(
        (a) =>
          a.user_id ==
          JSON.parse(localStorage.getItem('logged_in_qram')).user.id
      );
      return list != undefined
        ? [list]
        : storeList;
    },
    itemsApprovalId2() {
      const storeList = this.$store.state.master.daerah.list.approvalId2;
      
      if (storeList.length === 0 && this.editedItem && this.editedItem.approver_2_id) {
        return [{
          id: this.editedItem.approver_2_id,
          username: this.editedItem.approver_2,
          user_id: this.editedItem.approver_2_id,
        }];
      }
      
      return storeList;
    },
    errorValidation() {
      return this.$store.state.maintenanceSettlement.errors;
    },
    loading() {
      return this.$store.state.maintenanceSettlement.loading;
    },
    accountNumberErrors() {
      const errors = [];
      if (!this.$v.accountNumber.$dirty) return errors;
      if (!this.$v.accountNumber.required) {
        errors.push('Nomor Rekening Perusahaan is required');
      }
      if (!this.$v.accountNumber.numeric) errors.push('Must be numeric');
      if (!this.$v.accountNumber.isUnique) {
        if (this.errorValidation.accountNumber != null) {
          this.errorValidation.accountNumber.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    IDApprover1Errors() {
      const errors = [];
      if (!this.$v.IDApprover1.$dirty) return errors;
      if (!this.$v.IDApprover1.required) {
        errors.push('ID Approver 1 is required');
      }
      if (!this.$v.IDApprover1.isUnique) {
        if (this.errorValidation.approver_1 != null) {
          this.errorValidation.approver_1.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    IDApprover2Errors() {
      const errors = [];
      if (!this.$v.IDApprover2.$dirty) return errors;
      if (!this.$v.IDApprover2.required) {
        errors.push('ID Approver 2 is required');
      }
      if (!this.$v.IDApprover2.isUnique) {
        if (this.errorValidation.approver_2 != null) {
          this.errorValidation.approver_2.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
  },
  watch: {
    dialogMS(val) {
      if (!val) {
        this.cancelDialog();
      }
      if (val) {
        this.approver1Loaded = false;
        this.approver2Loaded = false;
        this.$store.commit('master/daerah/list/clearApprovalId');
        
        if (this.editedItem.approver_1_id) {
          this.IDApprover1 = {
            user_id: this.editedItem.approver_1_id,
            username: this.editedItem.approver_1,
          };
        }
        if (this.editedItem.approver_2_id) {
          this.IDApprover2 = {
            user_id: this.editedItem.approver_2_id,
            username: this.editedItem.approver_2,
          };
        }
      }
    },
    accountNumber: {
      handler(val) {
        this.getValidateRek(val);

        if (this.errorValidation != null) {
          if (
            this.errorValidation.accountNumber != null &&
            val != this.errorValidation.accountNumber
          ) {
            this.$store.commit(
              'maintenanceSettlement/clearErrorVariable',
              'account_number'
            );
          }
        }
      },
    },
    searchApprovalId1: {
      handler(val) {
        if (!this.approver1Loaded) return;
        if (val != null) {
          this.delayHitServiceA1 = setTimeout(() => {
            this.getApprovalId1(this.listUserRoles[0].value, val);
          }, dataDelayServiceHit);
        }
      },
    },
    searchApprovalId2: {
      handler(val) {
        if (!this.approver2Loaded) return;
        if (val != null) {
          this.delayHitServiceA2 = setTimeout(() => {
            this.getApprovalId2(this.listUserRoles[1].value, val);
          }, dataDelayServiceHit);
        }
      },
    },
    IDApprover1: {
      handler(val, oldVal) {
        if (val !== oldVal && this.errorValidation?.approver_1?.length > 0) {
          this.$store.commit(
            'maintenanceSettlement/clearErrorVariable',
            'approver_1'
          );
        }
      },
      deep: true,
    },
    IDApprover2: {
      handler(val, oldVal) {
        if (val !== oldVal && this.errorValidation?.approver_2?.length > 0) {
          this.$store.commit(
            'maintenanceSettlement/clearErrorVariable',
            'approver_2'
          );
        }
      },
      deep: true,
    },
  },
  methods: {
    async getValidateRek(val) {
      this.isloadingRekening = true;
      this.$store
        .dispatch('maintenanceSettlement/validate', {
          date,
          no_rekening: val,
        })
        .then(() => {
          this.isloadingRekening = false;
        });
    },
    async getApprovalId1(role, username = '', firstLoad = false) {
      this.isLoadingApprovalId1 = true;
      await this.$store
        .dispatch('master/daerah/list/getApprovalId1', {
          date,
          role,
          search: {
            username,
          },
        })
        .then(() => {
          if (firstLoad) {
            const oldApproval = this.itemsApprovalId1.find(
              (val) => val.username == username
            );
            if (oldApproval == undefined) {
              this.searchApprovalId1 = '';
            } else {
              this.IDApprover1 = oldApproval;
            }
          }
        })
        .finally(() => {
          this.isLoadingApprovalId1 = false;
        });
    },

    async getApprovalId2(role, username = '', firstLoad = false) {
      this.isLoadingApprovalId2 = true;
      await this.$store
        .dispatch('master/daerah/list/getApprovalId2', {
          date,
          role,
          search: {
            username,
          },
        })
        .then(() => {
          if (firstLoad) {
            const oldApproval = this.itemsApprovalId2.find(
              (val) => val.username == username
            );
            if (oldApproval == undefined) {
              this.searchApprovalId2 = '';
            } else {
              this.IDApprover2 = oldApproval;
            }
          }
        })
        .finally(() => {
          this.isLoadingApprovalId2 = false;
        });
    },

    onFocusApprover1() {
      if (!this.approver1Loaded) {
        this.approver1Loaded = true;
        this.getApprovalId1(this.listUserRoles[0].value, '', false);
      }
    },

    onFocusApprover2() {
      if (!this.approver2Loaded) {
        this.approver2Loaded = true;
        this.getApprovalId2(this.listUserRoles[1].value, '', false);
      }
    },

    cancelDialog() {
      this.accountNumber = '';
      this.IDApprover1 = { username: '', user_id: '' };
      this.IDApprover2 = { username: '', user_id: '' };

      this.$emit('closeCancelParent');
    },
    resetUniqueValidation() {
      this.$store.commit('maintenanceSettlement/clearErrors');
    },
    close() {
      this.dialog = false;
    },
    async save() {
      this.$store.commit('maintenanceSettlement/setFlashErrorMessage', '');
      this.resetUniqueValidation();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        await this.$store
          .dispatch('maintenanceSettlement/updateMerchant', {
            date,
            id: this.editedItem.id,
            account_number: this.accountNumber,
            approver_1: this.IDApprover1.user_id,
            approver_2: this.IDApprover2.user_id,
            index: this.editedItem.id,
          })
          .then((status) => {
            if (status) {
              this.cancelDialog();
              this.dialog = true;
              setTimeout(() => {
                this.dialog = false;
              }, 5000);

              showAlert(
                this.$store,
                'Update settlement success !',
                'mdi-check-circle',
                'green'
              );
            } else {
              showAlert(
                this.$store,
                'Error on update settlement !',
                'mdi-alert',
                'red'
              );
            }
          });
      }
    },

    isEmpty,
  },
};
</script>
